/**
 * 全局过滤器
 */

/**
 * 格式化 - 货币（带千分和2位小数）
 * @param {*} val 要格式化的值
 */
const formatCurrency = val => {
  return val
    .toFixed(2)
    .toString()
    .replace(/(\d{1,3})(?=(\d{3})+(?:$|\.))/g, '$1,')
}

/**
 * 格式化 - 数字千分位
 * @param {*} val 要格式化的值
 */
const formatPoint = val => {
  const nums = val.toString().split('.')
  nums[0] = nums[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',')
  return nums.join('.')
  // return val.toString().replace(/(\d{1,3})(?=(\d{3})+(?:$|\.))/g, '$1,');
}

/**
 * 格式化 - 数字千分位,保留小数点后n位
 * @param {*} val 要格式化的值
 * @param {*} digits 保留小数点位数
 */
const formatCurrencyPoint = (val, digits = 2) => {
  let newVal = parseFloat(val)
  if (!newVal) {
    return ''
  }
  const nums = newVal.toFixed(digits).toString().split('.')
  nums[0] = nums[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',')
  return nums.join('.')
  // return val.toString().replace(/(\d{1,3})(?=(\d{3})+(?:$|\.))/g, '$1,');
}

/**
 * 百分比过滤器(四舍五入)
 * @param digits 保留小数点位数
 */
const formatPercentage = (value, digits = 2) => {
  const ds = parseInt(digits, 10).toString() === 'NaN' ? 2 : Math.abs(digits)
  return `${Number(value * 100).toFixed(ds)}`
}

/**
 * 百分比过滤器(不进行四舍五入)
 * @param digits 保留小数点位数
 */
const formatPercentageNo = (value, digits = 2) => {
  const ds = parseInt(digits, 10).toString() === 'NaN' ? 2 : Math.abs(digits)
  value = (value * 100).toString()
  let index = value.indexOf('.')
  if (index !== -1) {
    value = value.substring(0, digits + index + 1)
  } else {
    value = value.substring(0)
  }
  return parseFloat(value).toFixed(digits)
}

/**
 * 历时：分钟转小时 48:59
 */
const formatDuration = value => {
  const hours = Math.floor(value / 60)
  const minutes = value % 60
  return `${hours}:${minutes < 10 ? `0${minutes}` : minutes}`
}

/**
 * 首字母大写
 */
const firstUpperCase = value => {
  let arr = value.toLowerCase().split(' ')
  let result = ''
  arr.forEach(val => {
    // console.log(val, '--', this);
    if (val[0]) result += ` ${val[0].toUpperCase()}${val.slice(1)}`
  })
  return result.substring(1)
}

/**
 * 去除文字多余空格
 */

const textRemoveSpace = value => {
  return value.replace(/\s+/g, ' ')
}

/**
 * 保留小数点后指定位数（不四舍五入，返回数字）
 * @param {number} val 要处理的数值
 * @param {number} digits 保留的小数位数，默认 2
 * @returns {number}
 */
const formatFixedNoRound = (val, digits = 2) => {
  if (typeof val !== 'number' || isNaN(val)) return 0
  const factor = Math.pow(10, digits)
  return Math.floor(val * factor) / factor
}

/**
 * 保留小数点后指定位数（四舍五入，返回数字）
 * @param {number} val 要处理的数值
 * @param {number} digits 保留的小数位数，默认 2
 * @returns {number}
 */
const formatFixedRound = (val, digits = 2) => {
  if (typeof val !== 'number' || isNaN(val)) return 0
  return Number(val.toFixed(digits))
}

export default {
  formatCurrency,
  formatPercentage,
  formatPercentageNo,
  formatDuration,
  formatPoint,
  formatCurrencyPoint,
  firstUpperCase,
  textRemoveSpace,
  formatFixedNoRound,
  formatFixedRound
}

export {
  formatCurrency,
  formatPercentage,
  formatPercentageNo,
  formatDuration,
  formatPoint,
  formatCurrencyPoint,
  firstUpperCase,
  textRemoveSpace,
  formatFixedNoRound,
  formatFixedRound
}
